"use client";

import Image from "next/image";
import { Eng, logoHeader, Thai } from "../assets";
import { useRouter } from "next/navigation";
import { useLocale } from "next-intl";
import type { AuthStatus, AuthUser } from "../hooks/useAuth";
import TeacherLogin from "./teacherLogin";

type HeaderProps = {
    authStatus: AuthStatus;
    user: AuthUser | null;
    onLogin: () => void | Promise<void>;
    onLogout: () => void | Promise<void>;
};

export default function Header({ authStatus, user, onLogin, onLogout }: HeaderProps) {
    const router = useRouter();
    const locale = useLocale();
    const nextLocale = locale === "th" ? "en" : "th";
    const localeFlag = locale === "th" ? Thai : Eng;
	const hasUser = authStatus === "authenticated" && !!user;

    const handleToggleLocale = () => {
      document.cookie = `eef_locale=${nextLocale}; path=/;`;
      router.refresh();
    };

	return (
		<>
		<header className="relative z-20 h-16 w-full bg-[#ffffff] shadow-[0_2px_10px_rgba(0,0,0,0.12)]">
			<div className="mx-auto flex h-full max-w-460 items-center justify-between">
				<button className="flex items-center mt-2" onClick={() => router.push("/")}>
					<Image src={logoHeader} alt="Thai Pila" priority className="h-8 w-auto" />
				</button>

				<div className="flex items-center gap-6 text-sm text-neutral-700">
					
					<button
						type="button"
						className="flex items-center gap-2 rounded-md px-2 py-1 hover:bg-neutral-100"
            onClick={handleToggleLocale}
            aria-label={`Switch language to ${nextLocale.toUpperCase()}`}
					>
                        <Image
                          src={localeFlag}
                          alt={locale === "th" ? "Thai" : "English"}
                          className="h-6 w-6"
                        />
						<span className="text-[#4E4E4E] text-lg">{locale === "th" ? "ไทย" : "EN"}</span>
					</button>

					{hasUser ? (
						<TeacherLogin
							mode="inline"
							status={authStatus}
							user={user}
							onLogin={onLogin}
							onLogout={onLogout}
						/>
					) : authStatus === "checking" ? (
						null
					) : (
						<div>
							{/* <button
								type="button"
								onClick={() => setShowLoginScreen(true)}
								className="rounded-lg bg-[#FDEF5C] px-4 py-2 transition hover:bg-[#fce94f] cursor-pointer"
							>
								<span className="text-[#2b2b2b] text-lg">เข้าสู่ระบบ</span>
							</button> */}
						</div>
					)}

				</div>
			</div>
		</header>
		</>
	);
}
